<div class="section-container" id="about">
    <div class="section-left">
      <h2>{{strings.about}}</h2>
    </div>

    <div class="section-right">
      <div class="about-section-wrapper">
        <div class="section-title">
          <h2 [innerHTML]="strings.aboutSectionTitle"></h2>
        </div>
        <div class="about-section-content">
          <p class="about-info" [innerHTML]="strings.aboutMeInfo"></p>
          <div class="about-image-container">
            <div class="about-image-wrapper">
              <div class="image-background">
              </div>
              <img src="assets/about/me.webp" alt="Amir Kasumovic" class="about-image">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
